import { render, staticRenderFns } from "./BaseTableFilterTags.vue?vue&type=template&id=5f001989&scoped=true&"
import script from "./BaseTableFilterTags.vue?vue&type=script&lang=js&"
export * from "./BaseTableFilterTags.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableFilterTags.vue?vue&type=style&index=0&id=5f001989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f001989",
  null
  
)

export default component.exports